import AbstractChannel from './AbstractChannel'

export default class ParkWhiz extends AbstractChannel {

  name = 'ocra_direct'
  title = 'Ocra Direct'
  titleShort = 'Direct'
  color = '#787878'

  supportedFeatures = ['blackouts']

}
